import { render, staticRenderFns } from "./submitPass.vue?vue&type=template&id=392f4667&scoped=true"
import script from "./submitPass.vue?vue&type=script&lang=js"
export * from "./submitPass.vue?vue&type=script&lang=js"
import style0 from "./submitPass.vue?vue&type=style&index=0&id=392f4667&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f4667",
  null
  
)

export default component.exports